export default "__VITE_ASSET__nWCp5guA__";